import React from "react";

export default function ArrowDownIcon({
	color = "#1A1C21",
	width = 24,
	height = 24,
}) {
	return (
		<svg
			width={width}
			height={height}
			viewBox="0 0 24 24"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
		>
			<path
				d="M18.6654 11.1666H8.5237L13.182 6.50825L11.9987 5.33325L5.33203 11.9999L11.9987 18.6666L13.1737 17.4916L8.5237 12.8333H18.6654V11.1666Z"
				fill={color}
			/>
		</svg>
	);
}
